<template>
  <div class="d-flex justify-end">
    <v-btn class="search-button" outlined color="success" @click="exportExcel">
      <v-icon left>mdi-file-excel</v-icon> Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import { header } from '@/modules/tuitionFee/financial-report/headerTable.js'
import utils from '@/plugins/utils'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      totalHeadFee: 'tuitionFeeReport/totalHeadFee',
      period: 'tuitionFeeReport/period'
    }),
  },
  methods: {
    async exportExcel() {
      this.$loading.active = true
      try {
        if (this.totalHeadFee.length > 0) {
          const listReport = JSON.parse(JSON.stringify(this.totalHeadFee))
          let filter = this.$options.filters
          const data = listReport.map(item => {
            item.title = item.headFee.title
            item.headFee = item.headFeeMoney
            item.deductionHeadFees = item.deductionFeeMoney
            item.arrearFees = item.arrearFeeMoney
            item.refundFees = item.refundFeeMoney
            item.total = item.totalMoney
            return item
          })
          utils.exportExcel(
            data,
            header,
            `Báo cáo kỳ đóng ${filter.convertFullDate(this.period.title)}`
          )
        }
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
